import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DateTime } from 'luxon';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { PeriodicStatisticDTO, PeriodType, StatisticsClient } from 'src/app/base/models/models.swagger.generated';

@Injectable()
export class PeriodicStatisticsService {

  constructor(
    private statisticsClient: StatisticsClient,
    private toastService: ToastService,
  ) { }

  public getPeriodicStatistics(vehicleId: number, periodType: PeriodType, fromUtc: DateTime, toUtc: DateTime): Observable<PeriodicStatisticDTO[]> {
    return this.statisticsClient.getPeriodicStatistics(vehicleId, periodType, fromUtc, toUtc)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', '', ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
}
